import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { AppBar, Grid, IconButton, Toolbar } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import HouseIcon from '@mui/icons-material/House';

import { creators as AdminActions } from '../../Reducers/Admin';
import appdata from '../../Services/appdata';
import Companies from './Companies';
import Users from './Users';

export default function Admin() {
  const companies = useSelector((state) => state.Admin.companies);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedCompany, setSelectedCompany] = useState(-1);
  
  useEffect(() => {
    getAllCompanies();
    // eslint-disable-next-line
  }, [dispatch]);

  const getAllCompanies = () => {
    dispatch(AdminActions.adminGetAllCompanies());
  };

  const onSignout = () => {
    appdata.localClear();
    appdata.clear();
  };

  return (
    <div style={{ height: '100%' }}>
      <AppBar position="relative">
        <Toolbar>
          <IconButton onClick={() => navigate('/')}>
            <HouseIcon />
          </IconButton>
          <IconButton onClick={onSignout} className="sign-out-but">
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Grid spacing={1} container>
        <Companies
          companies={companies}
          getAllCompanies={getAllCompanies}
          onSelectCompany={(companyId) => setSelectedCompany(companyId)}
        />
        <Users companyId={selectedCompany} />
      </Grid>
    </div>
  );
}
